import styled from 'styled-components'

const Heading = styled.div`
  padding-top: 14px;
  padding-right: 0;
  padding-bottom: 14px;
  padding-left: 0;
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  @media(max-width: 767px) {
    font-size: 14px;
  }
`

export default Heading
